import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_face",
  "use": "icon-icon_face-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_face\">\n  <path d=\"M1370.028 24.147a83.038 83.038 0 0 0-117.092 0l-800.05 800.078L141.24 512.577a83.038 83.038 0 0 0-117.092 0 83.038 83.038 0 0 0 0 117.092l370.18 370.18a83.038 83.038 0 0 0 117.091 0l858.61-858.61a83.038 83.038 0 0 0 0-117.092z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/user/icons/svg/icon_face.svg
// module id = iQdG
// module chunks = 12